import { ExitIcon, ProfileCircledIcon, SearchIcon } from '@iheartjane/reefer';
import type { Nullable } from '@iheartjane/types';

import { useGetStore } from '@jane/shared/data-access';
import type { Cart, EmptyCart, Store } from '@jane/shared/types';

import type { RootLoaderType } from '../../../data-access';
import { useKioskSpacing, useTypedRouteLoaderData } from '../../../hooks';
import { trackSignInTap } from '../../../util';
import { CartButton } from '../CartButton/CartButton';
import { IconButton } from '../IconButton/IconButton';

interface HeaderIconProps {
  cart?: Nullable<Cart | EmptyCart>;
  onCartButtonClick: () => void;
  onLoginIconClick: () => void;
  onLogoutIconClick: () => void;
  onSearchIconClick: () => void;
  signedIn: boolean;
  storeId: number;
}

export const HeaderIcons = ({
  cart,
  onCartButtonClick,
  onLoginIconClick,
  onLogoutIconClick,
  onSearchIconClick,
  signedIn,
  storeId,
}: HeaderIconProps) => {
  const { isIpad } = useKioskSpacing();

  const { store: initialStore } =
    useTypedRouteLoaderData<RootLoaderType>('root');
  const { data: store } = useGetStore<Store>(storeId, {
    initialData: initialStore,
  });
  const showSignIn =
    store?.kiosk_anonymous_checkout !== 'required' && store?.kiosk_allow_auth;

  const handleLoginClick = () => {
    trackSignInTap({
      store,
      source: ['Menu'],
    });
    onLoginIconClick();
  };

  return (
    <>
      <IconButton
        ariaLabel="search for products"
        onClick={onSearchIconClick}
        spacing={{
          marginLeft: 16,
          marginRight: 16,
        }}
        icon={<SearchIcon color="grays-black" size={isIpad ? 'lg' : 'xl'} />}
      />
      {showSignIn &&
        (signedIn ? (
          <IconButton
            ariaLabel="sign out of your account"
            onClick={onLogoutIconClick}
            spacing={{
              marginRight: 16,
            }}
            icon={<ExitIcon color="grays-black" size={isIpad ? 'lg' : 'xl'} />}
          />
        ) : (
          <IconButton
            ariaLabel="sign in to your account"
            onClick={handleLoginClick}
            spacing={{
              marginRight: 16,
            }}
            icon={
              <ProfileCircledIcon
                color="grays-black"
                size={isIpad ? 'lg' : 'xl'}
              />
            }
          />
        ))}
      <CartButton cart={cart} onClick={onCartButtonClick} storeId={storeId} />
    </>
  );
};
